module.exports = __webpack_public_path__ + "img/BIDV.3d6fe015.svg";